module.exports = __webpack_public_path__ + "static/poster5-f40c2c11f49a49a987325925874b7245.png";